import {omit} from 'external/lodash'
import {React, useContext, useMemo} from 'external/react'
import icons from 'resources/icons'

import { TeacherContext } from 'teacher/context'

export default function Icon (props) {
  const MyIcon = useMemo(() => {
    const MyIcon = icons[props.name]
    return MyIcon || <label>Missing Icon</label>
  }, [props.name])
  return <MyIcon {...props} />
}

export function IconLink (props) {

  const {icon} = props
  const {translate} = useContext(TeacherContext)
  const linkProps = useMemo(() => omit(props, ['icon', 'label']), [props]) 
  const label = useMemo(() => translate(props.label), [translate, props.label])
  return (
    <a {...linkProps}>
      <Icon name={icon} />
      <label className="label">
        {label}
      </label>
    </a>
  )
}
